import { httpRequest } from "@utils/HttpRequest";
import { IPage } from "@src/types/FmsTypes";
import { trasDsToTreeData } from "./dictModel";
import { IMdDictDetail, IMdDictFields, IMdDictSearch } from "./DictTypes";
import { getVrmBaseRequestUrl } from "@src/utils/constants";
class DictService {
    async insert(insertVo: IMdDictFields) {
        const apiUrl = "/base/dict/insert";
        return await httpRequest.post<IMdDictDetail>(apiUrl, insertVo, { baseURL: getVrmBaseRequestUrl() });
    }

    async update(updateVo: IMdDictFields) {
        const apiUrl = "/base/dict/update";
        return await httpRequest.post<IMdDictDetail>(apiUrl, updateVo, { baseURL: getVrmBaseRequestUrl() });
    }

    async disable(oneVo: IMdDictFields) {
        const apiUrl = "/base/dict/disable";
        return await httpRequest.post<boolean>(apiUrl, oneVo, { baseURL: getVrmBaseRequestUrl() })
    }

    async find(searchVo: IMdDictFields) {
        const apiUrl = "/base/dict/find";
        return await httpRequest.post<IMdDictDetail[]>(apiUrl, searchVo, { baseURL: getVrmBaseRequestUrl() })
    }

    async dictItemDs(pcode: string,) {
        let { retData } = await this.find({ pcode })
        return retData.map(el => ({
            label: el.name ?? "",
            value: el.code ?? ""
        }))
    }

    async page(searchVo: IMdDictSearch) {
        const apiUrl = "/base/dict/page";
        return await httpRequest.post<IPage<IMdDictDetail>>(apiUrl, searchVo, { baseURL: getVrmBaseRequestUrl() })
    }

    async one(oneVo: IMdDictFields) {
        const apiUrl = "/base/dict/one";
        return await httpRequest.post<IMdDictDetail>(apiUrl, oneVo, { baseURL: getVrmBaseRequestUrl() })
    }

    async allTree(searchVo: IMdDictFields) {
        const apiUrl = "/base/dict/allTree";
        searchVo.branchList = ["main", "portal"];
        return await httpRequest.post<IMdDictDetail[]>(apiUrl, searchVo, { baseURL: getVrmBaseRequestUrl() })
    }

    async oneTree(oneVo: IMdDictFields) {
        const apiUrl = "/base/dict/oneTree";
        return await httpRequest.post<IMdDictDetail>(apiUrl, oneVo)
    }

    async oneTreeDs(oneVo: IMdDictFields) {
        let { retData } = await this.oneTree(oneVo);
        let { children } = retData
        return children ? children.map(el => ({
            label: el.name ?? "",
            value: el.code ?? ""
        })) : []
    }

    async sync(searchVo: IMdDictFields) {
        const apiUrl = "/dict/sync";
        // searchVo.branchList = ["main", "portal"];
        return await httpRequest.post<boolean>(apiUrl, searchVo, {
            timeout: 15000
        })
    }

    async syncPage(searchVo: IMdDictSearch) {
        const apiUrl = "/dict/syncPage";
        searchVo.branchList = ["main", "portal"];
        return await httpRequest.post<boolean>(apiUrl, searchVo)
    }

    async syncOne(oneVo: IMdDictFields) {
        const apiUrl = "/dict/syncOne";
        return await httpRequest.post<boolean>(apiUrl, oneVo)
    }
    async accountTreeOne(code: string) {
        let { retData } = await this.allTree({ code })
        // return retData.map(el => ({
        //     label: el.name ?? "",
        //     value: el.code ?? "",
        //     codes: el.value ?? "",
        // }))
        let { children } = retData[0]
        console.log(retData)
        let treeData = trasDsToTreeData(children as IMdDictFields[], "code", "name");
        return treeData;
    }
}
export const dictService = new DictService();
